<div class="overlay" *ngIf="show">
    <div class="center">
        <mat-progress-spinner mode="indeterminate" value="40"></mat-progress-spinner>
    </div>
</div>
